import createSelector from 'web-app/util/custom-create-selector';

const getDraftsState = state => state.entities.drafts;

export const getDrafts = createSelector(getDraftsState, drafts => {
    return drafts.toList().sort((a, b) => b.createdAt.diff(a.createdAt));
});

export const getDraft = createSelector(
    getDraftsState,
    (state, props) => props.draftId,
    (drafts, draftId) => drafts.get(draftId),
);
